var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36788",
    "data-name": "Group 36788",
    transform: "translate(-1208 -2904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Swap",
    "data-name": "Iconly/Light-Outline/Swap",
    transform: "translate(1207.055 2903.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Swap",
    transform: "translate(2.083 3.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M16.451,3.093a.832.832,0,0,1,.824.719l.008.113V17.014l3.1-3.114a.832.832,0,0,1,1.26,1.08l-.08.094-4.523,4.544a.911.911,0,0,1-.084.073l.084-.073a.836.836,0,0,1-.131.107l-.05.03c-.016.01-.032.018-.049.026l-.049.021a.661.661,0,0,1-.065.024l-.04.011a.686.686,0,0,1-.072.015l-.035,0a.673.673,0,0,1-.082.006h-.032c-.027,0-.054,0-.081-.005l.1,0a.837.837,0,0,1-.133-.011.68.68,0,0,1-.072-.014l-.038-.011a.678.678,0,0,1-.071-.025l-.037-.017a.587.587,0,0,1-.057-.029l-.05-.032c-.013-.008-.025-.017-.038-.026l-.009-.008a.848.848,0,0,1-.083-.073h0l-4.523-4.544a.832.832,0,0,1,1.086-1.255l.093.081,3.1,3.116V3.925A.832.832,0,0,1,16.451,3.093ZM5.438.083h.016q.041,0,.081.006l-.1-.005a.838.838,0,0,1,.133.011.654.654,0,0,1,.071.014L5.685.12a.633.633,0,0,1,.064.022l.045.021a.564.564,0,0,1,.053.027l.044.027a.519.519,0,0,1,.044.03l.093.081,4.523,4.544A.832.832,0,0,1,9.465,6.126l-.093-.081L6.27,2.928V16.02a.832.832,0,0,1-1.656.113l-.008-.113V2.929L1.5,6.045a.832.832,0,0,1-1.083.083l-.093-.08A.832.832,0,0,1,.245,4.965l.08-.093L4.849.327,4.9.282,4.933.254,4.849.327A.835.835,0,0,1,4.98.22L5.03.19c.016-.01.032-.018.049-.026L5.129.143A.653.653,0,0,1,5.194.119L5.235.108A.662.662,0,0,1,5.3.093L5.343.088A.68.68,0,0,1,5.421.082Z",
    transform: "translate(-0.083 -0.082)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1113",
    "data-name": "Rectangle 1113",
    width: 24,
    height: 24,
    transform: "translate(1208 2904)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.f63b2f8d7e27bc11c27e158e76012154.svg";
export { ForwardRef as ReactComponent };